import { useComplaintHook } from 'hooks/complaint.hook';
import { useTranslation } from 'react-i18next';
import { Button, Stack } from 'styles';
import { TRANSLATION_KEYS } from 'utils/constants';

type Props = {
	isEditing: boolean;
	setIsEditing: React.Dispatch<React.SetStateAction<boolean>>;
	isComplaintDetails: boolean;
	handleNavigateBack: () => void;
	handleSaveComplaint: () => void;
	handleDiscardChanges: () => void;
};

const ComplaintDetailsButtons = ({
	isEditing,
	setIsEditing,
	isComplaintDetails,
	handleNavigateBack,
	handleSaveComplaint,
	handleDiscardChanges,
}: Props) => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});

	const { isEditEnabled } = useComplaintHook();

	const handleClick = () => {
		handleSaveComplaint();
	};

	return (
		<Stack
			direction={'row'}
			position={'absolute'}
			right={0}
			bottom={'20px'}
			sx={{
				gap: '20px',
				alignContent: 'center',
				justifyContent: 'flex-end',
			}}
		>
			{isEditing ? (
				<>
					{isComplaintDetails ? (
						<Button
							type="button"
							variant="outlined"
							fullWidth={false}
							onClick={handleDiscardChanges}
						>
							{tClientLabels('commons.buttons.back')}
						</Button>
					) : (
						<Button
							type="button"
							variant="outlined"
							fullWidth={false}
							onClick={handleNavigateBack}
						>
							{tClientLabels('commons.buttons.cancel')}
						</Button>
					)}
					<Button
						type="button"
						variant="contained"
						fullWidth={false}
						onClick={handleClick}
					>
						{tClientLabels('commons.buttons.save')}
					</Button>
				</>
			) : (
				<Button
					type="button"
					variant="contained"
					fullWidth={false}
					disabled={isEditEnabled}
					onClick={() => setIsEditing(true)}
				>
					{tClientLabels('commons.buttons.edit')}
				</Button>
			)}
		</Stack>
	);
};

export default ComplaintDetailsButtons;
